<template>
	<div class="modal fade" id="modal-blacklist">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Telefone</h4>
					<button type="button" class="close" data-dismiss="modal">
						<img :src="logotipo" style="width: 30px; height: 35px; opacity: 1;">
						&times;
					</button>
				</div>

				<div class="modal-body">

					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label>Telefone</label>
					        	<input type="text" id="resumo" class="form-control form-control-sm" v-model.number="estado.telefone" minlength="10" v-mask="['##########', '###########']">
							</div> 
						</div>

						<div class="col-md-8">
							<div class="form-group">
								<label  for="delito">Descrição</label>
					        	<input type="text" id="delito" class="form-control form-control-sm" v-model="estado.descricao">
							</div>
						</div>
					</div>

				</div>


				<div class="modal-footer">
					<button v-if="estado.id" class="btn btn-sm btn-danger" @click="delet">Excluir</button>
					<button class="btn btn-sm btn-success" @click="save">Salvar</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import api     from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"

	export default {
		name: "modal-blacklist",
		props: [ 'estado' ],
		mixins: [ api, replace ],

		computed: {
			logotipo() { return this.$store.state.config.logotipo },
			usuario()  { return this.$store.state.user }
		},

		methods: {
            save() {
				var aux = document.getElementById('resumo').value;
				if(aux.length >=10){
					if ( this.estado.id ) this.update()
					else this.create()
				}else{
					alert('Digite com o DDD o telefone')
					console.log(aux.length);
				}
            },

			async update() {
				const response = await this.PUT("Blacklist", this.estado)

				if ( response.status == "success") this.$emit("alert", { status: "success", result: "Dados atualizados com sucesso."} )
				else window.alert(response.result)
            },

            async create() {
				this.estado.call_in = 1
                const response = await this.POST("Blacklist", this.estado)

				if ( response.status == "success") this.$emit("alert", { status: "success", result: "Dados inseridos com sucesso."} )
				else window.alert(response.result)
            },

            async delet() {
                const response = await this.DELETE("Blacklist", this.estado.id)

                if ( response.status == "success") this.$emit("alert", { status: "success", result: "Dados deletados com sucesso."} )
				else window.alert(response.result)
            },
            
            toggle_block(payload) {
                switch (payload) {
                    case 'denuncia':
                        this.estado.denuncia = (this.estado.denuncia == 0) ? 1 : 0
                        break

                    case 'call_in':
                        this.estado.call_in  = (this.estado.call_in  == 0) ? 1 : 0
                        break

                    case 'call_out':
                        this.estado.call_out = (this.estado.call_out == 0) ? 1 : 0
                        break
                }
            }
		}
	}
</script>

<style scoped>
</style>
